// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@ces/App/Store/Reducers";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getById } from "@insite/client-framework/Store/Data/DataState";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import {
    chain,
    DispatchUpdateWishListLine,
    ReloadIfProductsHaveSameUnitOfMeasure,
    SetUpWishListLine,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateUnitOfMeasure";

export const xSetUpWishListLine: typeof SetUpWishListLine = props => {
    props.reloadAllLines = false;
    const state = props.getState();
    const wishListLine = getById(state.data.wishListLines, props.parameter.wishListLineId).value;
    if (!wishListLine) {
        throw new Error(`WishListLine not found for id ${props.parameter.wishListLineId}`);
    }

    props.updatedWishListLine = { ...wishListLine };
    props.updatedWishListLine.unitOfMeasure = props.parameter.unitOfMeasure;

    // XNG-Changes
    const productInfo = state.pages.myListDetails.productInfosByWishListLineId[props.parameter.wishListLineId];
    const multiplesOf =
        (state as CustomAppState).xSelectedUom.multiplesOfByProductId[props.parameter.wishListLineId] ||
        (state as CustomAppState).xSelectedUom.multiplesOfByProductId[wishListLine.productId];

    if (productInfo?.qtyOrdered) {
        props.updatedWishListLine.qtyOrdered = productInfo.qtyOrdered;
    } else if (multiplesOf) {
        props.updatedWishListLine.qtyOrdered = multiplesOf;
    }
};

export const xReloadIfProductsHaveSameUnitOfMeasure: typeof ReloadIfProductsHaveSameUnitOfMeasure = props => {
    const state = props.getState();
    const wishListLinesDataView = getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter);
    if (!wishListLinesDataView.value) {
        return;
    }

    // xng-change: reload all lines in case we have updated Selected UOM
    // if (
    //     wishListLinesDataView.value.find(
    //         o =>
    //             o.unitOfMeasure === props.parameter.unitOfMeasure &&
    //             o.productId === props.updatedWishListLine.productId,
    //     )
    // ) {
    // two products now have the same unit of measure, one will get deleted so reload all
    // props.reloadAllLines = true;
    props.dispatch({
        type: "Data/WishListLines/Reset",
    });
    props.dispatch(loadWishListLines());
    // }
};

export const xUpdateUOMToTheStore = (props: any) => {
    props.dispatch({
        type: "Pages/MyListDetails/UpdateQuantity",
        wishListLineId: props.apiResult.id,
        qtyOrdered: props.apiResult.qtyOrdered,
    });
};

replaceInChain(chain, SetUpWishListLine, xSetUpWishListLine);
replaceInChain(chain, ReloadIfProductsHaveSameUnitOfMeasure, xReloadIfProductsHaveSameUnitOfMeasure);
addToChainAfter(chain, DispatchUpdateWishListLine, xUpdateUOMToTheStore);
